// extracted by mini-css-extract-plugin
export default {"indicatorCountRoot":"icons_indicatorCountRoot__3ZaMh","indicatorCountNumber":"icons_indicatorCountNumber__CcIoR"};